import { DefaultPaymentMethodResponse } from 'vopay';
import { useState } from 'react';
import { BillingApi } from '#shared/components/AccountAndBilling/types';

// The op is host-supplied (account vs partner endpoint) — the (c) interface. This hook only owns the
// loading state and the Success check; the caller decides which endpoint the op hits.
export default function useFetchDefaultPaymentMethod(fetchOp: BillingApi['fetchDefaultPaymentMethod']) {
  const [fetching, setFetching] = useState(false);

  // Starts undefined (not a real value like 'vopay') so callers can tell "not loaded yet" apart
  // from a resolved default; it only becomes one of the legitimate values on success.
  const [defaultPaymentMethod, setDefaultPaymentMethod] =
    useState<DefaultPaymentMethodResponse['DefaultPaymentMethod']>();

  const fetchDefaultPaymentMethod: BillingApi['fetchDefaultPaymentMethod'] = async () => {
    try {
      setFetching(true);
      const res = await fetchOp();

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setDefaultPaymentMethod(res.DefaultPaymentMethod);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  };

  return { fetching, defaultPaymentMethod, fetchDefaultPaymentMethod };
}
